export class ClassRectComputed {
  constructor(selector = '.c-rect-wrapper', options) {
    this.selector = selector
    this.options = options
  }

  selectorW() {
    if (document.querySelector(this.selector)) {
      return document.querySelector(this.selector).clientWidth
    } else { return 0 }
  }
  selectorH() {
    if (document.querySelector(this.selector)) {
      return document.querySelector(this.selector).clientHeight
    } else { return 0 }
  }

  size({ minw, minh } = this.options) {
    let w = this.selectorW()
    let h = this.selectorH()
    let width = parseInt(w / 3)
    let height = parseInt(h / 2)

    return {
      width: width >= minw + 20 ? width - 10 : minw,
      height: height >= minh + 20 ? height : minh,
    }
  }

  position(width, height) {
    let w = this.selectorW()
    let h = this.selectorH()
    let min_px = 15
    
    let minw = this.options.minw + 100
    let minh = this.options.minh + 50

    const correctResult = (selector_v, v) => {
      let num = parseInt((selector_v / 2) - v)
      return num > 0 ? num : min_px
    }

    return {
      left: w >= minw ? correctResult(w, width) : min_px,
      top: h >= minh ? correctResult(h, height) : min_px
    }
  }
}